<template>
    <div>
        <DCard
            padding
        >
            <ProductPackageForm
                :errors="errors"
                :product-package="productPackage"
                :is-fulfillment-package="isFulfillmentPackage"
                :contract-max-nesting-level="contractMaxNestingLevel"
                @form-submitted="update"
            />
        </DCard>
    </div>
</template>

<script>
import ProductPackageForm from '~@/Components/Products/ProductPackages/Form'

export default {
    name: 'ProductPackageEdit',
    components: {
        ProductPackageForm
    },
    props: {
        productPackage: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isFulfillmentPackage: {
            type: Boolean,
            default: () => { return false }
        },
        contractMaxNestingLevel: {
            type: Number,
            default: () => { return 3 }
        }
    },
    methods: {
        update (form) {
            form.put(this.$route('products.product-packages.update', {
                product_package: this.productPackage.id
            }))
        }
    }
}
</script>

<style scoped>

</style>
